import { Select } from 'chakra-react-select'
import React from 'react'

const FormikSelect = ({ options, field, form, ...rest }) => (
    <Select
        key={field.name}
        options={options}
        name={field.name}
        value={
            options ? options.find(option => option.value === field.value) : ''
        }
        onChange={option => form.setFieldValue(field.name, option.value)}
        onBlur={field.onBlur}
        {...rest}
    />
)

export default FormikSelect
